import activateTab from './activateTab';
import addTab from './addTab';
import { TabType } from '../store/schema/TabViewState';
import { getStore as getTabStore } from '../store/tabStore';
import addChatTab from 'owa-skype/lib/utils/addChatTabActionCreator';
import { mutator } from 'satcheljs';

mutator(addChatTab, actionMessage => {
    for (const tab of getTabStore().tabs) {
        if (tab.type == TabType.FloatingChat && tab.data == actionMessage.chatConversationId) {
            activateTab(tab, true);
            return;
        }
    }
    addTab(
        TabType.FloatingChat,
        true /* isShown */,
        true /* makeActive */,
        actionMessage.chatConversationId
    );
});
